import React from 'react';
import PropTypes from 'prop-types';
import './FullPageImageBlock.scss';
import cn from 'classnames';
import BackgroundMedia from 'components/BackgroundMedia';
import { getFullScreenImageSources } from 'js/image-sources';

const FullPageImageBlock = ({ text, mediaClassName, background }) => {
  return (
    <div className="full-page-image-block">
      {background && (background.video || background.image) && (
        <BackgroundMedia
          className={cn({
            [mediaClassName]: mediaClassName,
          })}
          {...background}
          imageLoading="lazy"
          imageSources={getFullScreenImageSources()}
        />
      )}

      {text && (
        <div className="full-page-image-block__text-container">
          <div className="full-page-image-block__text">
            <span className="full-page-image-block__text-background">
              {text}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

FullPageImageBlock.propTypes = {
  text: PropTypes.string,
  background: PropTypes.exact(BackgroundMedia.propTypes),
  mediaClassName: PropTypes.string,
};

export default FullPageImageBlock;
